import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import DocSearch from '../DocSearch';
import ProductSelector from '../ProductSelector';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { useMediaQuery, Grow } from '@material-ui/core';

const styles = (theme) => ({
    rightToolbar: {
        alignSelf: 'baseline',
        marginLeft: 'auto',
        marginRight: 10,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    mobileOpenToolbar: {
        alignSelf: 'baseline',
        marginTop: '0.5em',
        marginLeft: 'auto',
        marginRight: 10,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
    },
    linksWrapper: {},
    floatContainer: {
        float: 'right',
    },
    supportLink: {
        fontWeight: 500,
        fontSize: '12px',
        paddingRight: '0px',
    },
    documentationLink: {
        fontSize: '12px',
        fontWeight: 'normal',
    },
    productSelector: {
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, 0%)',
        marginLeft: '0.7%',
    },
    searchIcon: {
        marginTop: '1.75rem',
    },
});

const SimpleMenu = (props) => {
    const matches = useMediaQuery('(max-width: 600px)');
    const { classes, selectedProduct, searchOpen, handleSearchToggle } = props;
    console.log('searchOpen', searchOpen);

    const renderMobileSearch = () => {
        if (!selectedProduct) return null;
        return !searchOpen ? (
            <SearchIcon className={classes.searchIcon} onClick={handleSearchToggle} />
        ) : (
            <DocSearch onClick={handleSearchToggle} inputAdornment={<CloseIcon onClick={handleSearchToggle} />} />
        );
    };

    // Rendering search for bigger screens
    const renderSearch = () => {
        //Reset the searchOpen state to be false
        if (searchOpen) {
            handleSearchToggle();
        }
        return selectedProduct ? <DocSearch inputAdornment={<SearchIcon />} /> : null;
    };

    return (
        <>
            <Hidden mdDown>
                <div className={classes.productSelector}>
                    <ProductSelector />
                </div>
            </Hidden>
            <div className={!searchOpen ? classes.rightToolbar : classes.mobileOpenToolbar}>
                <div className={classes.linksWrapper}>
                    {!matches && (
                        <div className={classes.floatContainer}>
                            <Button
                                color="inherit"
                                className={classes.documentationLink}
                                href="https://developer.signiant.com"
                                target="_blank"
                                id="devLink"
                            >
                                API Documentation
                            </Button>
                            <Button
                                color="secondary"
                                className={classes.supportLink}
                                href="https://support.signiant.com/hc/en-us/articles/360020531833-Contact-Support"
                                target="_blank"
                                id="supportLink"
                            >
                                Support
                            </Button>
                        </div>
                    )}
                </div>
                {matches ? renderMobileSearch() : renderSearch()}
            </div>
        </>
    );
};

export default withStyles(styles, { useTheme: true })(SimpleMenu);
